import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledTitle = styled.h1`
    padding: 0;
    margin: 0;
    color: white;
    font-size: 1.5rem;
    font-weight: bold;
`;

const PageTitle = (props) => {
  const {
    pageName,
  } = props;

  return (
    <StyledTitle>
      {pageName}
    </StyledTitle>
  );
};

PageTitle.propTypes = {
  pageName: PropTypes.string.isRequired,
};

export default PageTitle;
